import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';

import { store } from 'apps/homepage/store';
import { AppContainer } from './app/Container';

const container = document.getElementById('nft-landing-page');

if (container) {
  Modal.setAppElement(container);

  ReactDOM.render(
    <Provider store={store}>
      <AppContainer />
    </Provider>,
    container,
  );
}
